/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultStripeMerchantData interface.
 */
export function instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultStripeMerchantData(value) {
    if (!('PaymentIntentClientSecret' in value) || value['PaymentIntentClientSecret'] === undefined)
        return false;
    if (!('PublishableKey' in value) || value['PublishableKey'] === undefined)
        return false;
    if (!('SessionUrl' in value) || value['SessionUrl'] === undefined)
        return false;
    if (!('SessionClientSecret' in value) || value['SessionClientSecret'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultStripeMerchantDataFromJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultStripeMerchantDataFromJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultStripeMerchantDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'PaymentIntentClientSecret': json['PaymentIntentClientSecret'],
        'PublishableKey': json['PublishableKey'],
        'SessionUrl': json['SessionUrl'],
        'SessionClientSecret': json['SessionClientSecret'],
    };
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultStripeMerchantDataToJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultStripeMerchantDataToJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultStripeMerchantDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'PaymentIntentClientSecret': value['PaymentIntentClientSecret'],
        'PublishableKey': value['PublishableKey'],
        'SessionUrl': value['SessionUrl'],
        'SessionClientSecret': value['SessionClientSecret'],
    };
}
//# sourceMappingURL=FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultStripeMerchantData.js.map